import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import React from "react";
import CurrentEvents from "../CurrentEvents";

const { Panel } = Collapse;

const CurrentEventsAccordian = ({ fullwidthEvent }) => (
  <Collapse
    bordered={false}
    style={{ width: fullwidthEvent ? "100%" : "85%" }}
    defaultActiveKey={["CurrentEventsAccordian"]}
    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
    className="site-collapse-custom-collapse  sideItem">
    <Panel header="Current Events" key="Current Events" className="site-collapse-custom-panel">
      <CurrentEvents />
    </Panel>
  </Collapse>
);

export default CurrentEventsAccordian;
